import Link from 'next/link'
import { CMSLink } from '@/components/Link'
import { CardWithIconAndButton } from './cards/CardWithIconAndButton'
import { ChevronsRight } from 'lucide-react'
import RichText from '@/components/RichText'
import Image from 'next/image'

const ServiceBlock2 = (props: any) => {
  const { title, services, subtitle, eyebrow, hasCta, cta } = props

  return (
    <section
      className="container mx-auto 2xl:px-0 rounded-3xl relative"
      aria-label="Services"
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <header className="col-span-1 lg:col-span-2 flex flex-col justify-center">
          <div className=" text-left">
            {eyebrow && (
              <div className="border border-primary px-4 py-2 rounded-full mb-2 inline-flex items-center justify-center">
                <div className="text-primary">{eyebrow}</div>
              </div>
            )}
            {/* Render title as RichText directly, no wrapper */}
            {title && (
              <RichText
                data={title}
                enableGutter={false}
                enableProse={false}
                className="text-3xl font-semibold md:text-4xl lg:text-5xl text-left mb-3 md:mb-4 lg:mb-6"
              />
            )}
          </div>
          {/* Render subtitle as RichText directly, no wrapper */}
          {subtitle && (
            <div className="max-w-lg text-muted-foreground text-left text-base lg:text-lg break-words">
              <RichText data={subtitle} enableGutter={false} enableProse={false} className="" />
            </div>
          )}
        </header>
        {services.map((service: any, index: number) => (
          <article
            key={index}
            className="flex flex-col h-full"
            aria-label={typeof service.title === 'string' ? service.title : ''}
          >
            {/* CardWithIconAndButton now handles icon rendering and containment */}
            <CardWithIconAndButton
              {...service}
              textColor="text-card-foreground"
              btnClassName="border-none bg-transparent hover:bg-transparent text-card-foreground  font-semibold text-base tracking-wide transition-colors duration-300 group/link rounded-full px-0 py-0"
            />
          </article>
        ))}
      </div>
      {/* CTA button inside section, below grid */}
      {hasCta && cta?.url && cta?.label && (
        <div className="flex justify-center w-full mt-10">
          <CMSLink
            {...cta}
            className="z-10 inline-flex items-center border border-primary bg-primary text-primary-foreground hover:bg-primary/90 cursor-pointer font-semibold text-base tracking-wide transition-colors duration-300 rounded-full px-6 py-8"
          >
            <div className="w-12 h-12 rounded-full flex flex-1 items-center justify-center ml-2 bg-primary text-primary-foreground">
              <ChevronsRight />
            </div>
          </CMSLink>
        </div>
      )}
    </section>
  )
}

export default ServiceBlock2
